<div class="auth-page vh-100 bg-ggm position-relative overflow-hidden">
  <div class="wave-background-container">
    <div class="wave-layer wave-layer-1"></div>
    <div class="wave-layer wave-layer-2"></div>
    <div class="wave-layer wave-layer-3"></div>
  </div>

  @if (showNewOfficeIntro()) {
    <section class="new-office" data-testid="ov-new-office" aria-labelledby="new-office-title">
      <div class="new-office__card">
        @if ($branding.logoMenu(); as logo) {
          <img class="new-office__logo" [src]="logo" [alt]="$branding.displayName()" />
        }
        <h1 id="new-office-title">Te damos la bienvenida al área de propietarios</h1>
        <p>
          La hemos renovado para que consultar y gestionar tu información sea
          <strong>más fácil, rápido e intuitivo</strong>.
        </p>
        <p>Todo lo que necesitas, ahora con una experiencia más sencilla y pensada para ti.</p>
        <div class="new-office__discover">
          <p>
            <strong>¿Quieres descubrirla?</strong> Entra con tus datos de siempre y empieza a
            utilizarla.
          </p>
          <button type="button" data-testid="ov-new-office-try" (click)="tryNewVersion()">
            Entra ahora
          </button>
        </div>
        <p>
          Y si lo prefieres, durante un tiempo podrás seguir accediendo a la
          <a data-testid="ov-new-office-classic" [href]="previousOfficeUrl"
            >Oficina Virtual clásica</a
          >.
        </p>
        <nav class="new-office__areas" aria-label="Otras áreas">
          <a data-testid="ov-property-managers" [href]="propertyManagersOfficeUrl">
            Área administradores de fincas
          </a>
          <span class="new-office__areas-sep" aria-hidden="true">|</span>
          <a data-testid="ov-fixed-networks" [href]="fixedNetworksOfficeUrl">Área Redes Fijas</a>
        </nav>
      </div>
    </section>
  } @else {
    <div class="container-fluid h-100 position-relative z-index-content">
      <div
        class="h-100"
        [class]="view() !== 'REGISTER' ? 'd-flex align-items-center justify-content-center' : ''"
      >
        @switch (view()) {
          @case ('LOGIN') {
            <app-login (navigate)="view.set($event)" class="auth-form m-auto"></app-login>
          }
          @case ('DEMO') {
            <app-demo-login class="auth-form m-auto"></app-demo-login>
          }
          @case ('REGISTER') {
            <app-register (navigate)="view.set($event)"></app-register>
          }
          @case ('RECOVERY_PASSWORD') {
            <app-recovery-password
              class="auth-form mx-auto"
              (navigateTo)="view.set($event)"
            ></app-recovery-password>
          }
          @case ('CHANGE_PASSWORD') {
            <app-change-password
              class="mx-auto"
              (navigate)="view.set($event)"
            ></app-change-password>
          }
        }
      </div>
    </div>
  }
</div>
